import _styled from "styled-components";
import { useTranslation } from 'next-i18next';
import { Cog6ToothIcon } from '@heroicons/react/24/outline';
import { useIsFreemiumUser, useResponsiveBreakPoints } from '@restworld/utils-common';
import { Title } from '../title';
import { ButtonV2 } from '../button-v2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EmployerFlexibleSlotsCard(_ref) {
  var onManageClick = _ref.onManageClick,
      activeSlots = _ref.activeSlots,
      inactiveSlots = _ref.inactiveSlots;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isMobile = _useResponsiveBreakPo.isMobile;

  var isFreemiumUser = useIsFreemiumUser();
  return /*#__PURE__*/_jsxs(MainWrapper, {
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Title, {
        fontSize: "base",
        fontWeight: "semibold",
        textColor: "neutral-700",
        children: t('number_active_slots', {
          count: activeSlots
        })
      }), /*#__PURE__*/_jsx(Title, {
        fontSize: "base",
        fontWeight: "semibold",
        textColor: "neutral-100",
        children: t('number_inactive_slots', {
          count: inactiveSlots
        })
      })]
    }), /*#__PURE__*/_jsx(ButtonV2, {
      StartIcon: isFreemiumUser ? undefined : Cog6ToothIcon,
      variant: isMobile ? 'secondary-restworld' : 'tertiary',
      size: "sm",
      onClick: onManageClick,
      children: isFreemiumUser ? t('find_out_more') : t('manage')
    })]
  });
}
export default EmployerFlexibleSlotsCard;

var MainWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-flexible-slots-card__MainWrapper",
  componentId: "sc-18qcq87-0"
})(["", ""], {
  "display": "flex",
  "height": "100%",
  "width": "100%",
  "flex": "1 1 0%",
  "flexDirection": "column",
  "justifyContent": "space-between",
  "gap": "2rem",
  "borderRadius": "0.75rem",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(240 235 248 / var(--tw-bg-opacity))",
  "padding": "1.25rem",
  "@media (min-width: 768px)": {
    "borderWidth": "1px",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))"
  }
});